// Production-safe logger. console.* is suppressed in production builds.
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default log;
